export default __webpack_public_path__ + "static/media/home-bg-img.6c8098e3.jpg";